<template>
	<div class="qualification-body">
		<div class="qualification-container">
			<div class="qualification-header">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" :inline-message='true' label-width="110px" class="form-box">
					<div class="license-upload-body">
						<div class="license-box">
							<div class="fx-title">
								<p>营业许可证</p>
							</div>
							<div class="license-img-box">
								<ImgUpload
									class="show-img"
									:from="'license'"
									:quaEditDisable="editShow"
									ref="imgUpload0"
									:imgId.sync="showSrc[0].id"
									:location="showSrc[0].location"
									:imgSrc.sync="showSrc[0].src"
									:hasFile.sync="showSrc[0].hasFile"
									:uploadError.sync="showSrc[0].uploadError"/>
								<div class="verify-box">
									<el-form-item label="有效日期：">
										<el-date-picker :unlink-panels='true' size="mini" v-model="ruleForm.effectiveDate1" type="daterange" :disabled="!editShow" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"/>
									</el-form-item>
									<el-form-item label="证件状态：">
										<span :class="licencestatus1 === '已过期' ? 'redText' : 'blackText'">{{licencestatus1}}</span>
									</el-form-item>
								</div>
							</div>
						</div>
						<div class="license-box">
							<div class="fx-title">
								<p>食品卫生许可证</p>
							</div>
							<div class="license-img-box">
								<ImgUpload
									class="show-img"
									:location="showSrc[1].location"
									:imgSrc.sync="showSrc[1].src"
									:imgId.sync="showSrc[1].id"
									:uploadError.sync="showSrc[1].uploadError"
									:hasFile.sync="showSrc[1].hasFile"
									:from="'license'"
									:quaEditDisable="editShow"
									ref="imgUpload1"/>
								<div class="verify-box">
									<el-form-item label="有效日期：">
										<el-date-picker :unlink-panels='true' size="mini" v-model="ruleForm.effectiveDate2" type="daterange" :disabled="!editShow" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"/>
									</el-form-item>
									<el-form-item label="证件状态：">
										<span :class="licencestatus2 === '已过期' ? 'redText' : 'blackText'">{{licencestatus2}}</span>
									</el-form-item>
								</div>
							</div>
						</div>
						<div class="license-box">
							<div class="fx-title">
								<p>食品流通许可证</p>
							</div>
							<div class="license-img-box">
								<ImgUpload
									class="show-img"
									:location="showSrc[2].location"
									:imgSrc.sync="showSrc[2].src"
									:imgId.sync="showSrc[2].id"
									:uploadError.sync="showSrc[2].uploadError"
									:hasFile.sync="showSrc[2].hasFile"
									:from="'license'"
									:quaEditDisable="editShow"
									ref="imgUpload2"/>
								<div class="verify-box">
									<el-form-item label="有效日期：">
										<el-date-picker :unlink-panels='true' size="mini" v-model="ruleForm.effectiveDate3" type="daterange" :disabled="!editShow" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"/>
									</el-form-item>
									<el-form-item label="证件状态：">
										<span :class="licencestatus3 === '已过期' ? 'redText' : 'blackText'">{{ licencestatus3 }}</span>
									</el-form-item>
								</div>
							</div>
						</div>
					</div>
				</el-form>
			</div>
		</div>
		<div class="store-info-btn">
			<el-button class="btn" size='small' type="primary" @click="savePost">提交</el-button>
		</div>
	</div>
</template>

<script>
import ImgUpload from '@/components/goodsManagement/goodsInfo/ImgUpload.vue'
export default {
	name: 'currentCom',
	components: {
		ImgUpload
	},
	props: {
		qualificationShow: Boolean,
		editDisable: {
			type: Boolean,
			default: true
		}
	},
	data () {
		return {
			licencestatus1: '',
			licencestatus2: '',
			licencestatus3: '',
			applyId: '',
			shopid: '',
			id: '',
			operating: '综合',
			rangeShow: true,
			dateShow: true,
			isfirst: true,
			qualificationDate: '',
			statusIcon: '',
			ruleForm: {
				range: 1,
				opendate: '',
				effectiveDate1: [],
				effectiveDate2: [],
				effectiveDate3: []
			},
			rules: {
				opendate: [
					{ required: true, message: '请输入开通日期', trigger: 'blur' }
				],
				effectiveDate1: [
					{ required: true, message: '请输入有效日期', trigger: 'blur' }
				],
				effectiveDate2: [
					{ required: true, message: '请输入有效日期', trigger: 'blur' }
				],
				effectiveDate3: [
					{ required: true, message: '请输入有效日期', trigger: 'blur' }
				]
			},
			showSrc: [
				{ src: '', id: '0', licencetypeid: '1', location: '0', uploadError: false, licencetypename: '营业执照', verifyStatus: '待审核', hasFile: '0' },
				{ src: '', id: '0', licencetypeid: '2', location: '1', uploadError: false, licencetypename: '食品卫生许可证', verifyStatus: '待审核', hasFile: '0' },
				{ src: '', id: '0', licencetypeid: '3', location: '2', uploadError: false, licencetypename: '食品流通许可证', verifyStatus: '待审核', hasFile: '0' }
			],
			editShow: true
		}
	},
	created () {
		this.getInfo()
	},
	methods: {
		getInfo () {
			let params = {
				shopid: sessionStorage.getItem('storeid')
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/licenceapply`,
				data: params
			}).then(res => {
				if (res.result) {
					if (res.data.length === 0) {
						return false
					}
					this.applyId = res.data[0].applyid
					res.data.forEach(item => {
						if (item.licencetypeid === 1) {
							this.showSrc[0].src = item.url
							this.showSrc[0].hasFile = item.url ? '1' : '0'
							this.showSrc[0].id = item.id
							this.showSrc[0].detailid = item.detailid
							this.licencestatus1 = this.initData(item.licencestatus)
							this.ruleForm.effectiveDate1 = [item.begindate.split(' ')[0], item.enddate.split(' ')[0]]
						} else if (item.licencetypeid === 2) {
							this.showSrc[1].src = item.url
							this.showSrc[1].hasFile = item.url ? '1' : '0'
							this.showSrc[1].id = item.id
							this.showSrc[1].detailid = item.detailid
							this.licencestatus2 = this.initData(item.licencestatus)
							this.ruleForm.effectiveDate2 = [item.begindate.split(' ')[0], item.enddate.split(' ')[0]]
						} else {
							this.showSrc[2].src = item.url
							this.showSrc[2].hasFile = item.url ? '1' : '0'
							this.showSrc[2].id = item.id
							this.showSrc[2].detailid = item.detailid
							this.licencestatus3 = this.initData(item.licencestatus)
							this.ruleForm.effectiveDate3 = [item.begindate.split(' ')[0], item.enddate.split(' ')[0]]
						}
					})
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		initData (data) {
			let text = ''
			switch (data) {
			case 0:
				text = '未生效'
				break
			case 1:
				text = '正常'
				break
			case 2:
				text = '已过期'
				break
			}
			return text
		},
		translateImgArr (func) {
			return new Promise((resolve, reject) => {
				let previewArr = this.showSrc.reduce((pre, cur, index) => {
					let curSrc = this.$refs[`imgUpload${index}`][func]()
					if (curSrc) {
						pre.push(curSrc)
					}
					return pre
				}, [])
				if (previewArr.length === 0) {
					reject(previewArr)
				} else {
					resolve(previewArr)
				}
			})
		},
		uploadAsync: async function (uploadFileArr) {
			for (let i = 0; i < uploadFileArr.length; i++) {
				await this.$refs[`imgUpload${uploadFileArr[i]}`].uploadImgHandler()
			}
			this.getInfo()
		},
		check (data) {
			let flag = true
			data.forEach((item, index) => {
				if ((!item.begindate && this.$refs[`imgUpload${index}`].getCurrentSrc() !== '') || (item.begindate && this.$refs[`imgUpload${index}`].getCurrentSrc() === '')) {
					flag = false
				}
			})
			return flag
		},
		savePost () {
			let detailList = []
			detailList = [
				{ url: this.showSrc[0].src, licencetypeid: '1', id: this.showSrc[0].detailid },
				{ url: this.showSrc[1].src, licencetypeid: '2', id: this.showSrc[1].detailid },
				{ url: this.showSrc[2].src, licencetypeid: '3', id: this.showSrc[2].detailid }
			]
			if (this.ruleForm.effectiveDate1 && this.ruleForm.effectiveDate1.length > 0) {
				detailList[0].begindate = this.ruleForm.effectiveDate1[0] + ' 00:00:01'
				detailList[0].enddate = this.ruleForm.effectiveDate1[1] + ' 23:59:59'
			}
			if (this.ruleForm.effectiveDate2 && this.ruleForm.effectiveDate2.length > 0) {
				detailList[1].begindate = this.ruleForm.effectiveDate2[0] + ' 00:00:01'
				detailList[1].enddate = this.ruleForm.effectiveDate2[1] + ' 23:59:59'
			}
			if (this.ruleForm.effectiveDate3 && this.ruleForm.effectiveDate3.length > 0) {
				detailList[2].begindate = this.ruleForm.effectiveDate3[0] + ' 00:00:01'
				detailList[2].enddate = this.ruleForm.effectiveDate3[1] + ' 23:59:59'
			}
			if (!this.check(detailList)) {
				this.$message.error('请完善信息')
				return false
			}
			let params = {
				id: this.applyId,
				shopid: sessionStorage.getItem('storeid'),
				detailList: detailList
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/licenceapply/addOrUpdate`,
				data: params
			}).then(res => {
				if (res.result) {
					let data = res.data
					this.showSrc.forEach(item => {
						data.detailList.forEach(dataItem => {
							if (dataItem.licencetypeid === item.licencetypeid) {
								item.id = dataItem.id
							}
						})
					})
					this.translateImgArr('hasImgFile').then(arr => {
						this.uploadAsync(arr)
					}).catch(() => {
						this.getInfo()
						this.$message.success('提交成功！')
					})
				} else {
					this.$message.error(res.msg)
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.qualification-body {
	display: flex
	flex: 1
	height: 100%
	flex-direction column
	min-height: 0
	.qualification-container {
		display: flex;
		flex: 1;
		overflow-y: auto;
		flex-direction: column;
		/deep/.el-form-item__label {
			width: auto!important
			padding-right: 0!important
		}
		/deep/.el-form-item__content {
			margin-left: 0!important
		}
		.qualification-header {
			padding-top: 10px
			text-align left
			position relative
			.condition-box {
				padding: 5px 0
				&:nth-of-type(3) {
					padding-left: 8px
				}
				.required-sign {
					color: red
					margin-right: 4px
				}
			}
			.status {
				position absolute
				top: 30px
				left: 600px
				.status-icon {
					display inline-block
					width: 108px
					height: 56px
				}
				.pass {
					background-image: url('~images/icon/pass.png')
				}
				.pending {
					background-image: url('~images/icon/pending.png')
				}
				.fail {
					background-image: url('~images/icon/no-pass.png')
				}
				.expired {
					background-image: url('~images/icon/expired.png')
				}
			}
			.license-upload-body {
				display flex
				flex: 1
				flex-direction column
				text-align left
				.license-box {
					margin-bottom: 20px
					border-top: 1px solid #DEE3FC
					&:nth-of-type(1) {
						border: none
					}
					.fx-title {
						margin 10px 0 0 0
					}
					.license-img-box {
						display flex
						.img-info {
							width: 395px
							height: 200px
							padding 20px 20px 0 0
							overflow: hidden;
							box-sizing:border-box
							float left
							img {
								display block
								width: 100%
								height: 100%
								border-radius: 6px
							}
						}
						.verify-box {
							flex: 1
							padding-top: 20px
							font-size 14px
							p {
								font-weight 700
								margin-bottom 10px
							}
							span {
								color: red
								margin-right: 4px
							}
						}
					}
				}
			}
		}
	}
	.redText{
		color:red !important
	}
	.blackText{
		color: #000 !important
	}
	.store-info-btn {
		text-align left
		padding: 20px 0
		.btn {
			width :130px;
			height :35px;
			margin-left :20px;
		}
	}
}
</style>
